<script setup>
import { useDisplay } from 'vuetify'

const nuxtApp = useNuxtApp()

const props = defineProps({
    seller: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
    showHeader: {
        type: Boolean,
        default: false,
    },
    showButton: {
        type: Boolean,
        default: false,
    },
    howMany: {
        type: Number,
        default: 30,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `seller-${props.handle}-${props.howMany}-products`,
    () => $fetch(`/api/product/query?id=${props.seller}&what=seller&howMany=${props.howMany}`),
    {
        transform: (data) => {
            return {
                sellerProducts: data.products.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})
</script>

<template>
    <v-row id="sellerproducts" class="justify-center rounded">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="10"><app-loader /></v-col>
        <v-col v-else cols="10" sm="10">
            <v-row class="justify-center">
                <v-col v-for="product in data.sellerProducts" :key="product.id" cols="12" sm="6" lg="3">
                    <product-card-seller :product="product" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
